import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuDivider,
    Heading,
} from "@chakra-ui/react";

import React, { memo } from "react";

const DropDown = ({ title, items, action }) => {
    return (
        <Menu>
            <MenuButton as={"button"}>{action}</MenuButton>
            <MenuList>
                {title && (
                    <>
                        <Heading
                            as="h2"
                            size={["xs", "sm"]}
                            className="py-1 px-3 text-primary-color-500"
                        >
                            {title}
                        </Heading>
                        <MenuDivider />
                    </>
                )}
                {items.map(i => (
                    <MenuItem
                        className="hover:bg-light-color"
                        key={i.id}
                        onClick={i.clickHandler}
                    >
                        {i.name}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};

export default memo(DropDown);
